// If you no longer need to support IE11, you can remove these polyfills.
// import "react-app-polyfill/ie11";
// import "react-app-polyfill/stable";
import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { Amplify } from "aws-amplify";
import { amplifyConfig } from './amplifyconfiguration.js'
import App from "./App";
import { ErrorBoundary } from "./components/Common/ErrorBoundary";
import * as Sentry from "@sentry/browser";
import "./index.css";
import * as serviceWorker from "./serviceWorkerRegistration.js";
import { store } from './store'; // Assuming this exports your configured store
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import theme from "./theme/theme";
import { AbilityContext, ability } from './components/Abilities'

//console.log(config)
//SENTRY INIT
Sentry.init({
  dsn: "https://b0a89123415f4055a5a70acbf60cf93e@sentry.io/1882439",
  release:
    process.env.REACT_APP_STAGE +
    "@" +
    process.env.REACT_APP_VERSION +
    (process.env.REACT_APP_BUILD
      ? "." + parseInt(process.env.REACT_APP_BUILD, 10)
      : ""),
      environment: process.env.REACT_APP_STAGE
});

Amplify.configure(amplifyConfig);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <AbilityContext.Provider value={ability}>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <ErrorBoundary>
            <BrowserRouter>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <App className="font-montserrat"/>
              </LocalizationProvider>
            </BrowserRouter>
          </ErrorBoundary>
        </ThemeProvider>
      </Provider>
    </AbilityContext.Provider>
  // </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
